<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="text-center mb-3">
    <h5 class="mb-1">Sign In</h5>
    <p>Sign in to Start Manage your DreamsTour Account</p>
  </div>
  <div class="mb-2">
    <label class="form-label">Email</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-user"></i>
      </span>
      <input type="text" class="form-control form-control-lg" placeholder="Enter Email" formControlName="username">
    </div>
    <div *ngIf="loginForm.get('username')?.invalid && (loginForm.get('username')?.touched || loginForm.get('username')?.dirty)" class="text-danger fs-13 mt-1">
      Username is required.
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Password</label>
    <div class="pass-group input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-lock"></i>
      </span>
      <input [type]="password[0] ? 'text' : 'password'" class="pass-input form-control" placeholder="Enter Password" formControlName="password" />
      <span class="isax toggle-password" [ngClass]="password[0] ? 'isax-eye' : 'isax-eye-slash'"
        (click)="togglePassword(0)" (keydown.enter)="togglePassword(0)" tabindex="0"></span>
    </div>
    <div *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)" class="text-danger fs-13 mt-1">
      Password is required.
    </div>
  </div>

   <p class="fs-12 text-danger">{{ errorString }}</p>

  <div class="mt-3 mb-3">
    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
      <div class="form-check d-flex align-items-center mb-2">
        <input class="form-check-input mt-0" type="checkbox" value="" id="remembers_me">
        <label class="form-check-label ms-2 text-gray-9 fs-14" for="remembers_me">
          Remember Me
        </label>
      </div>
      <a href="javascript:void(0);" class="link-primary fw-medium fs-14 mb-2" (click)="forgotPassword()">Forgot Password?</a>
    </div>
  </div>
  <div class="mb-3">
    <button type="submit" class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
      [disabled]="loginForm.invalid">Login<i class="isax isax-arrow-right-3 ms-2"></i></button>
  </div>
  <div class="login-or mb-3">
    <span class="span-or">Or</span>
  </div>
  <div class="d-flex align-items-center mb-3">
    <a (click)="onCustomGoogleLogin()" class="btn btn-light flex-fill d-flex align-items-center justify-content-center me-2" >
      <img src="assets/img/icons/google-icon.svg" class="me-2" alt="Img">Google
    </a>
    <!-- <a href="javascript:void(0);" class="btn btn-light flex-fill d-flex align-items-center justify-content-center" (click)="signInWithFacebook()">
      <img src="assets/img/icons/fb-icon.svg" class="me-2" alt="Img">Facebook
    </a> -->
  </div>
  <div class="d-flex justify-content-center">
    <p class="fs-14">Don't you have an account? <a href="javascript:void(0);" class="link-primary fw-medium"
        (click)="signUp()">Sign up</a></p>
  </div>
</form>
